import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'btn-delete-file',
	template: require('./btn-delete-file.html')
})
export class BtnDeleteFile {
	@Input() file: File;
	@Input() text: string;
	@Input() snEmpty: boolean;
	@Output() deleteFile: EventEmitter<File> = new EventEmitter<File>();

	constructor() {}

	onDeleteFile(file: File) {
		this.deleteFile.emit(file);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/jobs/common/btn-delete-file/btn-delete-file.ts